import { Select, Input  } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import Icon, { CloseIcon } from '../Icon';

import './styles.scss';
import cn from 'classnames';

const HTTPS = 'https://';
const HTTP = 'http://';

const InputHttp = ({
  targetRef,
  className,
  allowClear,
  suffix,
  numericRegex,
  parseNumericRegex,
  isFormatNumber,
  defaultValue,
  value,
  ...rest
}) => {
  const [protocol, setProtocol] = useState(HTTPS);
  const [domain, setDomain] = useState('');

  const handleDomainChange = (e) => {
    var newValue = typeof e === 'string' ? e : e.target.value;
    newValue = formatValue(newValue);
    setDomain(newValue);
    rest.onChange?.(`${protocol}${newValue}`);
  };

  const handleProtocolChange = (val) => {
    setProtocol(val);
    rest.onChange?.(`${val}${domain}`);
  };

  const handleClear = () => {
    setDomain('');
    rest.onChange?.('');
  };

  useEffect(() => {
    if (typeof value === 'string') {
      if (value.startsWith(HTTPS)) {
        setProtocol(HTTPS);
        setDomain(value.replace(HTTPS, ''));
      } else if (value.startsWith(HTTP)) {
        setProtocol(HTTP);
        setDomain(value.replace(HTTP, ''));
      } else {
        // If no protocol, keep existing or fallback
        setDomain(value);
      }
    }
  }, [value]);

  const suffixIcon = useMemo(() => {
    if (allowClear && rest.value?.length) {
      return <Icon component={CloseIcon} onClick={handleClear} />;
    }
    return suffix;
  }, [suffix, allowClear, rest.value, rest.onChange]);

  const classNames = useMemo(() => {
    return cn('input-custom my-input-white', className);
  }, [className]);

  const selectBefore = (
    <Select 
      value={protocol}
      className='addon-select'
      disabled={rest.disabled}
      onChange={(value) => {
        handleProtocolChange(value);
      }}
    >
      <Select.Option value="http://">http://</Select.Option>
      <Select.Option value="https://">https://</Select.Option>
    </Select>
  );

  const formatValue = (value) => {
    value = value.trim();

    if (value.startsWith('http://') || value.startsWith('https://')) {
      value = value.replace(/^(http:\/\/|https:\/\/)/, '');
    }
    return value;
  }

  const renderInputHttp = useMemo(() => {
    return (
      <Input
        className={classNames} 
        {...rest} 
        addonBefore={selectBefore} 
        suffix={suffixIcon}
        onChange={handleDomainChange}
        ref={targetRef}
        value={domain}
      />
    );
  }, [rest]);

  return <div id="my-input">{renderInputHttp}</div>;
};

InputHttp.defaultProps = {
  numericRegex: /^-?\d*(\.\d*)?$/,
  parseNumericRegex: /,/gi,
  isFormatNumber: false,
};

export default InputHttp;
